/**
 * FileSearchInput
 *
 * Search box used in the breadcrumbs row of File Management.
 * Parent owns the value/debouncing — this component is purely presentational.
 */

import SearchIcon from "../../../../../../../../assets/svg/search-icon";
import type { FileSearchInputProps } from "../types/fileManagement.types";

const FileSearchInput = ({ value, onChange }: FileSearchInputProps) => {
  return (
    <div className="flex items-center gap-1 h-[26px] w-[200px] px-1.5 py-2 rounded-[6px] border border-border-gray dark:border-border-gray-dk bg-popper-bg dark:bg-popper-bg-dk shrink-0">
      <SearchIcon className="w-[14px] h-[14px] text-verba-indigo dark:text-verba-indigo-dk shrink-0" />
      <input
        type="text"
        placeholder="Search files & folders"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="flex-1 min-w-0 bg-transparent outline-none border-none text-md font-normal text-heading-text dark:text-heading-text-dk placeholder:text-gray-placeholder dark:placeholder:text-gray-placeholder-dk"
      />
    </div>
  );
};

export default FileSearchInput;
